import { CountResponse } from '@interfaces/common.interface';
import {
  Contact,
  CountContactsRequestParams,
  CreateContactRequestBody,
  GetContactsRequestParams,
  GetContactsXlsxRequestParams,
  UpdateContactRequest,
} from '@interfaces/contact.interface';

import api from './';

export const {
  useCountContactsQuery,
  useCreateContactMutation,
  useDeleteContactMutation,
  useGetManyContactsQuery,
  useGetPatientByIdQuery,
  useUpdateContactMutation,
  useLazyGetContactsXlsxQuery,
} = api.injectEndpoints({
  endpoints: (build) => ({
    getManyContacts: build.query<Contact[], GetContactsRequestParams>({
      query: (params) => ({
        url: 'contacts',
        params,
      }),
      providesTags: ['contacts'],
    }),
    countContacts: build.query<CountResponse, CountContactsRequestParams>({
      query: (params) => ({ url: 'contacts/count', params }),
      providesTags: ['contacts'],
    }),
    getPatientById: build.query<void, Contact>({
      query: (id) => ({
        url: `contacts/${id}`,
        providesTags: ['contacts'],
      }),
    }),
    createContact: build.mutation<Contact, CreateContactRequestBody>({
      query: (body) => ({
        url: `contacts`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['contacts'],
    }),
    updateContact: build.mutation<Contact, UpdateContactRequest>({
      query: ({ id, body }) => ({
        url: `contacts/${id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['contacts'],
    }),
    deleteContact: build.mutation<Contact, number>({
      query: (id) => ({
        url: `contacts/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['contacts'],
    }),
    getContactsXlsx: build.query<Blob, GetContactsXlsxRequestParams>({
      query: (params) => ({
        url: 'contacts/xlsx',
        responseHandler: async (response) => await response.blob(),
        cache: 'no-cache',
        params,
      }),
    }),
  }),
});
